import { Component, DestroyRef, inject, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { PlRouter } from '@shared/services/pl-router.service';
import { ActivatedRoute, Params } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ComponentType } from '@angular/cdk/overlay';
import { DetailsTabComponent } from '@app/profile/detailsTab/detailsTab.component';
import { FriendsSurveyStatusComponent } from '@app/profile/friendsSurveyStatus/friendsSurveyStatus.component';
import { CertificatesTabComponent } from '@app/profile/certificatesTab/certificatesTab.component';
import { I18nService } from '@app/i18n';

export const queryParamKeyTab: string = 'tab' as const;

export enum ProfileTabs {
  certificates = 'certificates',
  details = 'details',
  survey360 = '360_survey',
}

type ProfileTabComponent = DetailsTabComponent | FriendsSurveyStatusComponent | CertificatesTabComponent;

interface TabContent {
  component: ComponentType<ProfileTabComponent>;
  tabLabel: string;
  tabLabelUrl: ProfileTabs;
}

@Component({
  selector: 'pl-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileComponent implements OnInit {
  private destroyRef: DestroyRef = inject(DestroyRef);

  public tabs: WritableSignal<TabContent[]> = signal(this.getTabContent());

  public selectedTabIndex: WritableSignal<number> = signal(0);

  constructor(
    private i18nService: I18nService,
    private plRouter: PlRouter,
    private route: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (queryParams: Params): void => {
        const tabToSelectUrlLabel: string | undefined = queryParams[queryParamKeyTab];
        let indexTabToSelect: number = this.tabs().findIndex(
          (tab: TabContent): boolean => tab.tabLabelUrl === tabToSelectUrlLabel,
        );
        if (indexTabToSelect === -1) {
          indexTabToSelect = 0;
        }
        this.selectedTabIndex.set(indexTabToSelect);
      },
    });
  }

  public onTabChange(indexNewTabSelected: number): void {
    console.log('TONIO ProfileComponent onTabChange indexNewTabSelected=', indexNewTabSelected);

    const urlTabLabelForSelectedTab: string = this.tabs()[indexNewTabSelected].tabLabelUrl;
    this.plRouter.navigate([], {
      queryParams: {
        [queryParamKeyTab]: urlTabLabelForSelectedTab,
      },
      queryParamsHandling: 'merge',
    });
  }

  private getTabContent(): TabContent[] {
    return [
      {
        component: DetailsTabComponent,
        tabLabel: this.i18nService.translate('profile.details.title'),
        tabLabelUrl: ProfileTabs.details,
      },
      {
        component: FriendsSurveyStatusComponent,
        tabLabel: this.i18nService.translate('profile.360_survey'),
        tabLabelUrl: ProfileTabs.survey360,
      },
      {
        component: CertificatesTabComponent,
        tabLabel: this.i18nService.translate('profile.certificates.tab_title'),
        tabLabelUrl: ProfileTabs.certificates,
      },
    ];
  }
}
